import { Breakpoints, PrimaryColors } from '@/common/theme/constants';

import { SxProps } from '@mui/material';

export const accordionStyles: SxProps = {
  backgroundColor: 'transparent',
  border: 'none',
  width: '100%',

  borderBottom: `1px solid ${PrimaryColors.carbon}`,
  '&:first-of-type': {
    borderTop: `1px solid ${PrimaryColors.carbon}`,
  },
};

export const accordionSummaryStyles: SxProps = {
  paddingInline: '16px',
  paddingBlock: '24px',
  '&.Mui-focusVisible': {
    outline: `1px solid ${PrimaryColors.white}`,
  },
};

export const accordionIconStyles: SxProps = {
  color: 'inherit',
  fontSize: '20px',

  [`@media (min-width:${Breakpoints.md}px)`]: {
    fontSize: '24px',
  },
};

export const accordionDetailsStyles: SxProps = {
  fontSize: '0.875rem',
  textAlign: 'left',
  padding: '0 16px',
  marginBottom: '24px',
};

export const accordionDetailsRichTextStyles: SxProps = {
  display: 'block',
};

export const accordionActionsStyles: SxProps = {
  justifyContent: 'flex-start',
  padding: '0 16px',
};

export const accordionActionsFooterStyles: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  marginBottom: '1rem',
};

export const accordionActionsButtonWrapperStyles: SxProps = {
  display: 'flex',
  gap: '15px',
};

export const accordionActionsButtonStyles: SxProps = {
  gap: '15px',
  paddingBlock: '9px',
  paddingInline: '20px',
  span: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
};
